import { Component, Input, OnInit } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { HttpErrorResponse } from '@angular/common/http';


import { Constants } from '../../common/constants';
import { IUser, IUserReponseAPI, ISideMenu, IPermission } from '../../models';
import { CommonService } from '../../services/common.service';
import { SettingsService } from '../../services/settings/settings.service';
import { Permissions } from '../../classes/permissions';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-sidebar',
  imports: [
    MatListModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    MatTooltipModule
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {

  applicationVersion: string = Constants.applicationVersion;
  applicationName: string = Constants.applicationName;

  profileDetail: IUser = {} as IUser;

  list: ISideMenu[] = [
    { name: Constants.screenNames.dashboard, path: Constants.routingPaths.dashboard, is_visible: true },
    { name: Constants.screenNames.screeens, path: Constants.routingPaths.screeens, is_visible: false },
    { name: Constants.screenNames.contents, path: Constants.routingPaths.contents, is_visible: false },
    { name: Constants.screenNames.compositions, path: Constants.routingPaths.compositions, is_visible: false },
    { name: Constants.screenNames.broadcasts, path: Constants.routingPaths.broadcasts, is_visible: false },
    { name: Constants.screenNames.apps, path: Constants.routingPaths.apps, is_visible: false },
    { name: Constants.screenNames.launcher, path: Constants.routingPaths.launcher, is_visible: false },
    { name: Constants.screenNames.templates, path: Constants.routingPaths.templates, is_visible: false },
    { name: Constants.screenNames.dzynflix, path: Constants.routingPaths.dzynflix, is_visible: false },
    { name: Constants.screenNames.reports, path: Constants.routingPaths.reports, is_visible: false },
  ];

  @Input() collapsed = true;

  constructor(private commonService: CommonService, private settingsService: SettingsService) { }

  ngOnInit(): void {
    this.loadProfileDetail();
  }

  get isSmallerScreen() {
    return window.innerWidth <= 900;
  }

  loadProfileDetail() {
    this.commonService.getProfileDetails().subscribe({
      next: (data: IUserReponseAPI) => {
        // console.log(data);
        this.profileDetail = data?.data ? data.data : {} as IUser;
        this.commonService.profileDetail = this.profileDetail;
        if (this.profileDetail.is_admin) {
          this.commonService.userPermission = [];
          this.commonService.isPermissionLoaded = true;
          this.setPermissions();
        }
        else {
          this.loadPermissionDetail();
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    })
  }

  loadPermissionDetail() {
    const roleId = this.profileDetail.role_id ?? this.profileDetail.role;

    if (!roleId) {
      this.commonService.userPermission = [];
      this.commonService.isPermissionLoaded = true;
      this.setPermissions();
      return;
    }

    this.settingsService.getPermissionByRoleID(roleId).subscribe({
      next: (permissions: IPermission[]) => {
        this.commonService.userPermission = permissions?.length > 0 ? permissions : [];
        this.commonService.isPermissionLoaded = true;
        this.setPermissions();
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    })
  }

  setPermissions() {
    this.list = this.list.map(x => {
      if (x.name != Constants.screenNames.dashboard && x.name != Constants.screenNames.users) {
        x.is_visible = Permissions.canView(x.name, this.commonService);
        if (x.name === Constants.screenNames.launcher) {
          x.is_visible = x.is_visible && this.commonService.isLauncherAvailable();
        }
      }
      else if (x.name === Constants.screenNames.users) {
        x.is_visible = !(this.profileDetail?.created_by);
      }
      return x;
    });
  }

  getIcon(name: string): string {
    return `sidebar_icons/${name.toLowerCase()}.svg`;
  }

}
